"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.function.bind");
require("core-js/modules/es.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("isomorphic-unfetch");
var _check = require("./functions/check");
var _exists = require("./functions/exists");
var _getMe = require("./functions/getMe");
var _signOut = require("./functions/signOut");
var _signInWithCustomToken = require("./firebase/signInWithCustomToken");

/* eslint-disable camelcase */
var AccountUtils = function AccountUtils(url, firebase) {
  (0, _classCallCheck2["default"])(this, AccountUtils);
  (0, _defineProperty2["default"])(this, "validateCookies", function () {
    var xss_token = _jsCookie["default"].get('xss_token', {
      domain: 'localhost'
    });
    return !!xss_token;
  });
  this.url = url;
  this.firebase = firebase;
  this.check = _check.check.bind(this);
  this.exists = _exists.exists.bind(this);
  this.getMe = _getMe.getMe.bind(this);
  this.signOut = _signOut.signOut.bind(this);
  this.signInWithCustomToken = _signInWithCustomToken.signInWithCustomToken.bind(this);
};
exports["default"] = AccountUtils;